let currentLang = 'pt';
let translations = {};

const SUPPORTED_LANGS = ['pt', 'en', 'it'];
const STORAGE_KEY = 'loyol-lang';

// Flatten nested objects into dot-notation keys: { a: { b: 'x' } } → { 'a.b': 'x' }
function flatten(obj, prefix = '') {
  const result = {};
  for (const key in obj) {
    const fullKey = prefix ? `${prefix}.${key}` : key;
    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      Object.assign(result, flatten(obj[key], fullKey));
    } else {
      result[fullKey] = obj[key];
    }
  }
  return result;
}

function detectLanguage() {
  // Check URL path: /en, /it, /pt
  const pathLang = window.location.pathname.replace(/^\/|\/$/g, '').toLowerCase().split('/')[0];
  if (SUPPORTED_LANGS.includes(pathLang)) {
    localStorage.setItem(STORAGE_KEY, pathLang);
    return pathLang;
  }

  if (!pathLang) {
    localStorage.setItem(STORAGE_KEY, 'pt');
    return 'pt';
  }

  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && SUPPORTED_LANGS.includes(stored)) return stored;

  const nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
  if (nav.startsWith('pt')) return 'pt';
  if (nav.startsWith('it')) return 'it';
  if (nav.startsWith('en')) return 'en';
  return 'pt';
}

function applyTranslations() {
  const lang = translations[currentLang];
  if (!lang) return;

  // data-i18n → textContent
  document.querySelectorAll('[data-i18n]').forEach(el => {
    const key = el.getAttribute('data-i18n');
    if (lang[key] !== undefined) {
      el.textContent = lang[key];
    }
  });

  // data-i18n-html → innerHTML
  document.querySelectorAll('[data-i18n-html]').forEach(el => {
    const key = el.getAttribute('data-i18n-html');
    if (lang[key] !== undefined) {
      el.innerHTML = lang[key];
    }
  });

  // data-i18n-attr → attribute values (format: "attr1:key1;attr2:key2")
  document.querySelectorAll('[data-i18n-attr]').forEach(el => {
    const pairs = el.getAttribute('data-i18n-attr').split(';');
    pairs.forEach(pair => {
      const [attr, key] = pair.split(':');
      if (attr && key && lang[key] !== undefined) {
        el.setAttribute(attr.trim(), lang[key]);
      }
    });
  });

  // Show/hide elements restricted to a specific language
  document.querySelectorAll('[data-lang-only]').forEach(el => {
    el.style.display = el.getAttribute('data-lang-only') === currentLang ? '' : 'none';
  });

  // Update <html lang>
  const langMap = { pt: 'pt-br', en: 'en', it: 'it' };
  document.documentElement.lang = langMap[currentLang] || currentLang;

  // Update <title> and <meta description>
  if (lang['meta.title']) {
    document.title = lang['meta.title'];
  }
  const metaDesc = document.querySelector('meta[name="description"]');
  if (metaDesc && lang['meta.description']) {
    metaDesc.setAttribute('content', lang['meta.description']);
  }

  // Update Open Graph and Twitter meta tags
  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle && lang['meta.title']) {
    ogTitle.setAttribute('content', lang['meta.title']);
  }
  const ogDesc = document.querySelector('meta[property="og:description"]');
  if (ogDesc && lang['meta.description']) {
    ogDesc.setAttribute('content', lang['meta.description']);
  }
  const twitterTitle = document.querySelector('meta[name="twitter:title"]');
  if (twitterTitle && lang['meta.title']) {
    twitterTitle.setAttribute('content', lang['meta.title']);
  }
  const twitterDesc = document.querySelector('meta[name="twitter:description"]');
  if (twitterDesc && lang['meta.description']) {
    twitterDesc.setAttribute('content', lang['meta.description']);
  }

  // Update og:locale
  const ogLocale = document.querySelector('meta[property="og:locale"]');
  if (ogLocale) {
    const localeMap = { pt: 'pt_BR', en: 'en_GB', it: 'it_IT' };
    ogLocale.setAttribute('content', localeMap[currentLang] || 'pt_BR');
  }
}

export function setLanguage(lang) {
  if (!SUPPORTED_LANGS.includes(lang)) return;
  currentLang = lang;
  localStorage.setItem(STORAGE_KEY, lang);
  applyTranslations();

  // Notify footer to update active state
  document.dispatchEvent(new CustomEvent('loyol-lang-changed', { detail: { lang } }));
}

export function getCurrentLanguage() {
  return currentLang;
}

export function initI18n(commonTranslations, pageTranslations) {
  // Merge common + page translations for each language, flattening nested objects
  SUPPORTED_LANGS.forEach(lang => {
    translations[lang] = {
      ...flatten(commonTranslations[lang] || {}),
      ...flatten(pageTranslations[lang] || {})
    };
  });

  currentLang = detectLanguage();
  applyTranslations();

  // Notify footer (and any other listeners) of the detected language
  document.dispatchEvent(new CustomEvent('loyol-lang-changed', { detail: { lang: currentLang } }));
}
